import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EntTypeProduct } from "../../../../models/handBooks/typeProduct";
import { useLazyGetProductTypeListQuery } from "../../../../redux/api/handBooksApi/productTypesApi";
import { AddTypeProductModal } from "./AddTypeProductModal";
import { useTypeProduct } from "./useTypeProduct";
import { EntTypeProductFilter } from "../../../../models/filters/TypeProductFilter";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { FilterTypeProduction } from "./FilterTypeProduction";

enum FormField {
  name,
  unitMeasurementId,
  directionId,
}

export const TypeProduct = () => {

  const [form] = useForm();
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal();
  const [selectedProductType, setSelectedProductType] = useState<EntTypeProduct>(new EntTypeProduct());
  const [showModal, setShowModal] = useState<boolean>(false);
  const { onAddTypeProduct, onEditTypeProduct, onDeleteTypeProduct } = useTypeProduct(modal, () => {
	searchHandleClick()
  })
  const [height, setHeight] = useState<number>(0);

  const [getData] = useLazyGetProductTypeListQuery();
  const {
	fetching,
	data,
	access,
	filter,
	totalItems,
	setData,
	setFetching,
	setFilter,
	setCurrentPage
  } = useGetDataOnScroll<EntTypeProduct, EntTypeProductFilter>({
	initialFilter: new EntTypeProductFilter(),
	query: getData
  });


  const openAddModal = (item: EntTypeProduct) => {
	setSelectedProductType(item);
	setShowModal(true);
  }
  const setEntityFromFields = (): EntTypeProductFilter => {
	let item: EntTypeProductFilter = _.clone(filter);
	item.name = form.getFieldValue(FormField.name) ?? null;
	item.unitMeasurementId = form.getFieldValue(FormField.unitMeasurementId) ?? null;
	item.directionId = form.getFieldValue(FormField.directionId) ?? null;
	item.page = 1;
	return item;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	  { name: FormField.directionId, value: null },
	  { name: FormField.unitMeasurementId, value: null },
	]);
  }
  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }
  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th>{ t('titles.units_of_measurement') }</th>
		  <th>{ t('titles.direction') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>{ i18n.language === 'ru' ? item.unitMeasurement?.nameRu : item.unitMeasurement?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.directions?.nameRu : item.directions?.nameKy }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteTypeProduct(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.type_product') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary">{ t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntTypeProduct)
		} }>
		  { t('handbooks.type_product.add_type_product') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterTypeProduction onSearch={ searchHandleClick }
									   onReset={ () => {
										 clearFields();
										 searchHandleClick()
									   } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
		width={ 800 }
	  />
	  <AddTypeProductModal
		typeProduct={ selectedProductType }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedProductType.id !== 0 ? onEditTypeProduct : onAddTypeProduct }
	  />
	  { contextHolder }
	</>
  )
}
